var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMonitorias(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "42423DC2-DAE3-48D5-8A1A-F4EF404C36CA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.home-aba/concursos",
    transform: "translate(-24.000000, -517.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-monitorias",
    transform: "translate(0.000000, 285.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,14 C15.6887547,14 17.8818181,16.1223067 17.9953805,18.7831104 L18,19 L18,21 C18,21.5522847 17.5522847,22 17,22 C16.4871642,22 16.0644928,21.6139598 16.0067277,21.1166211 L16,21 L16,19 C16,17.4023191 14.75108,16.0963391 13.1762728,16.0050927 L13,16 L5,16 C3.40231912,16 2.09633912,17.24892 2.00509269,18.8237272 L2,19 L2,21 C2,21.5522847 1.55228475,22 1,22 C0.487164161,22 0.0644928393,21.6139598 0.00672773133,21.1166211 L0,21 L0,19 C0,16.3112453 2.12230671,14.1181819 4.78311038,14.0046195 L5,14 L13,14 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,2 C6.23857625,2 4,4.23857625 4,7 C4,9.76142375 6.23857625,12 9,12 C11.7614237,12 14,9.76142375 14,7 C14,4.23857625 11.7614237,2 9,2 Z M9,4 C10.6568542,4 12,5.34314575 12,7 C12,8.65685425 10.6568542,10 9,10 C7.34314575,10 6,8.65685425 6,7 C6,5.34314575 7.34314575,4 9,4 Z",
    id: "Oval",
    fill: "#1717CE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0317541,14.8800003 C19.1698251,14.3452528 19.7152523,14.0236831 20.2499997,14.1617541 C22.3827066,14.712416 23.8947586,16.5896121 23.994728,18.773074 L24,19 L24,21 C24,21.5522847 23.5522847,22 23,22 C22.4871642,22 22.0644928,21.6139598 22.0067277,21.1166211 L22,21 L22.0000003,19.0007459 C21.9989805,17.6335842 21.0737494,16.440036 19.7500003,16.0982459 C19.2152528,15.9601749 18.8936831,15.4147477 19.0317541,14.8800003 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03125,2.88196081 C15.1682383,2.34693496 15.7130133,2.02426174 16.2480392,2.16125 C18.4604327,2.72771223 20.0078433,4.72123893 20.0078433,7.005 C20.0078433,9.28876107 18.4604327,11.2822878 16.2480392,11.84875 C15.7130133,11.9857383 15.1682383,11.663065 15.03125,11.1280392 C14.8942617,10.5930133 15.216935,10.0482383 15.7519608,9.91125 C17.0793969,9.57137266 18.0078433,8.37525664 18.0078433,7.005 C18.0078433,5.63474336 17.0793969,4.43862734 15.7519608,4.09875 C15.216935,3.96176174 14.8942617,3.41698667 15.03125,2.88196081 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonitorias);
export default __webpack_public_path__ + "static/media/ic-monitorias.3d4c62b8641ecc56e947ad71a0136298.svg";
export { ForwardRef as ReactComponent };